import React from 'react';
import { motion } from 'framer-motion';

const AnimatedLine = ({ startX, startY, endX, endY, color, radius }) => {
  return (
    <svg
      width={Math.abs(endX - startX) + 100}
      height={Math.abs(endY - startY) + 100}
    >
      <motion.circle
        cx={startX}
        cy={startY}
        r={radius}
        fill={color}
        initial={{ r: 0 }}
        animate={{ r: [0, radius, 0, 0, 0, 0] }}
        transition={{
          duration: 3,
          repeat: Infinity,
          repeatDelay: 1,
        }}
      />
      <motion.line
        x1={startX}
        y1={startY}
        x2={endX}
        y2={endY}
        stroke={color}
        strokeWidth={radius * 2}
        strokeLinecap="round"
        initial={{ x2: 50 }}
        animate={{
          x2: [startX, startX, endX, endX, endX, endX],
          y2: [startY, startY, endY, endY, endY, endY],
          x1: [startX, startX, startX, endX, endX, endX],
          y1: [startY, startY, startY, endY, endY, endY],
          strokeWidth: [0, radius * 2, radius * 2, radius * 2, 0, 0],
        }}
        transition={{
          duration: 3,
          repeat: Infinity,
          repeatDelay: 1,
        }}
      />
      <motion.circle
        cx={endX}
        cy={endY}
        r={radius}
        fill={color}
        initial={{ r: radius }}
        animate={{ r: [0, 0, 0, radius, 0, 0] }}
        transition={{
          duration: 3,
          repeat: Infinity,
          repeatDelay: 1,
        }}
      />
    </svg>
  );
};

export default AnimatedLine;
